import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["data", "loading", "refetch"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import List from "@/components/List";
import { useModal, useOrdersLazyQuery } from "@/hooks";
import { ORDER_PAGE_LIMIT, PAYMENT_METHOD_ID } from "@/lib/constants";
import dayjs from "@/lib/day";
import styles from "@/styles/Account.module.scss";
import paymentHistoryStyles from "@/styles/AccountPaymentHistory.module.scss";
import { useCallback, useEffect, useMemo, useState } from "react";
import { SelectField } from "../Form/Parts";
import InvoiceModal from "./InvoiceModal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function Order(_ref) {
  var _item$payment_instrum, _item$payment_instrum2, _item$payment_instrum3, _item$values, _item$values$discount, _item$values2, _item$values3;
  let {
    item
  } = _ref;
  const {
    showModal,
    hideModal
  } = useModal();
  const onDark = true;
  const paymentDateFormatted = item.created_at && dayjs(item.created_at).format("YYYY/MM/DD HH:mm") || "";
  const paymentMethod = (_item$payment_instrum = item.payment_instrument) === null || _item$payment_instrum === void 0 ? void 0 : _item$payment_instrum.payment_method_id;
  const cardNumber = (_item$payment_instrum2 = item.payment_instrument) === null || _item$payment_instrum2 === void 0 || (_item$payment_instrum2 = _item$payment_instrum2.values) === null || _item$payment_instrum2 === void 0 ? void 0 : _item$payment_instrum2.card_number;
  const cardType = (_item$payment_instrum3 = item.payment_instrument) === null || _item$payment_instrum3 === void 0 || (_item$payment_instrum3 = _item$payment_instrum3.values) === null || _item$payment_instrum3 === void 0 ? void 0 : _item$payment_instrum3.card_type;
  const cardNumberFormatted = " ****-****-****-" + cardNumber;
  const price = item.payment_amount;
  const name = item.name;
  const type = item.order_type;
  const productPrice = (_item$values = item.values) === null || _item$values === void 0 ? void 0 : _item$values.product_price;
  const discountName = (_item$values$discount = (_item$values2 = item.values) === null || _item$values2 === void 0 ? void 0 : _item$values2.discount_name) !== null && _item$values$discount !== void 0 ? _item$values$discount : "-";
  const transactionStartAt = (_item$values3 = item.values) === null || _item$values3 === void 0 ? void 0 : _item$values3.transaction_start_at;

  // ガイドライン同意ダイアログ表示
  const displayInvoiceModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(InvoiceModal, {
      name: name,
      paymentDate: item.created_at,
      transactionStartAt: transactionStartAt,
      price: price,
      productPrice: productPrice,
      discountName: discountName
    }), {
      closeButton: true,
      outerAreaClose: true,
      style: "InvoiceModal",
      onclose: hideModal
    });
  }, [item]);
  return /*#__PURE__*/_jsxs("div", {
    className: paymentHistoryStyles.orderEach,
    children: [/*#__PURE__*/_jsx("div", {
      className: paymentHistoryStyles.paymentDate,
      children: paymentDateFormatted
    }), /*#__PURE__*/_jsx("div", {
      className: paymentHistoryStyles.name,
      children: name
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentHistoryStyles.paymentMethod,
      children: [/*#__PURE__*/_jsx("span", {
        className: paymentHistoryStyles.paymentMethodIcon,
        children: /*#__PURE__*/_jsx(PaymentIconImage, {
          paymentMethodId: paymentMethod,
          cardType: cardType,
          onDark: onDark
        })
      }), (paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS || paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_3DS) && /*#__PURE__*/_jsx("span", {
        className: paymentHistoryStyles.cardNumber,
        children: cardNumberFormatted
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentHistoryStyles.price,
      children: [!isNaN(price) && type == "tvod" && `価格:${numberWithCommas(price)}円`, !isNaN(price) && type == "svod" && `月額:${numberWithCommas(price)}円`]
    }), /*#__PURE__*/_jsxs("div", {
      className: paymentHistoryStyles.detail,
      onClick: displayInvoiceModal,
      children: ["\u660E\u7D30", /*#__PURE__*/_jsx("wbr", {}), "\u8868\u793A"]
    })]
  });
}
export default function PaymentHistory(_ref2) {
  var _orderData$data, _orderData$data2;
  let {} = _ref2;
  const initialYear = new Date().getFullYear();
  const {
    0: year,
    1: setYear
  } = useState(initialYear);
  const [getOrdersQuery, _ref3] = useOrdersLazyQuery({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only"
  });
  const {
      data,
      loading,
      refetch: refetchOrdersQuery
    } = _ref3,
    queryResult = _objectWithoutProperties(_ref3, _excluded);
  const orderData = data === null || data === void 0 ? void 0 : data.orders;
  const years = useMemo(() => {
    let returnArr = [];
    let tempYear = initialYear;
    for (let i = 0; i < 7; i++) {
      if (tempYear - i >= 2021) returnArr.push(tempYear - i);
    }
    return returnArr;
  }, [initialYear]);
  const options = years.map(year => {
    return {
      label: year + "年",
      value: year
    };
  });
  const handleOnChange = useCallback(option => {
    setYear(option.value);
    refetchOrdersQuery({
      offset: 0,
      limit: ORDER_PAGE_LIMIT,
      year: option.value
    });
  }, [refetchOrdersQuery]);
  useEffect(() => {
    getOrdersQuery({
      variables: {
        offset: 0,
        limit: ORDER_PAGE_LIMIT,
        year: initialYear
      }
    });
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles.paymentHistory,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.contentsInner,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.contentBox,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.contentHeader,
          children: [/*#__PURE__*/_jsxs("h3", {
            className: styles.contentTitle,
            children: [year, "\u5E74\u306E\u304A\u652F\u6255\u3044\u5C65\u6B74"]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.yearSelect,
            children: /*#__PURE__*/_jsx(SelectField, {
              options: options,
              defaultValue: options[0],
              onChange: handleOnChange
            })
          })]
        }), (orderData === null || orderData === void 0 || (_orderData$data = orderData.data) === null || _orderData$data === void 0 ? void 0 : _orderData$data.length) !== 0 && /*#__PURE__*/_jsxs("div", {
          className: styles.contentBody,
          children: [/*#__PURE__*/_jsxs("div", {
            className: paymentHistoryStyles.paymentHistoryList,
            children: [/*#__PURE__*/_jsxs("div", {
              className: paymentHistoryStyles.header,
              children: [/*#__PURE__*/_jsx("div", {
                className: paymentHistoryStyles.date,
                children: "\u6C7A\u6E08\u65E5"
              }), /*#__PURE__*/_jsx("div", {
                className: paymentHistoryStyles.name,
                children: "\u5185\u5BB9"
              }), /*#__PURE__*/_jsx("div", {
                className: paymentHistoryStyles.payment,
                children: "\u652F\u6255\u65B9\u6CD5"
              }), /*#__PURE__*/_jsx("div", {
                className: paymentHistoryStyles.price,
                children: "\u91D1\u984D"
              }), /*#__PURE__*/_jsx("div", {
                className: paymentHistoryStyles.detail
              })]
            }), /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({
              items: orderData,
              limit: ORDER_PAGE_LIMIT,
              loading: loading
            }, queryResult), {}, {
              itemComponent: Order
            }))]
          }), /*#__PURE__*/_jsx("div", {
            className: styles.info,
            children: /*#__PURE__*/_jsxs("p", {
              children: ["\u203B\u6700\u5927\u3067\u904E\u53BB7\u5E74\u5206\u304C\u8868\u793A\u3055\u308C\u307E\u3059", /*#__PURE__*/_jsx("br", {}), "\u203B\u3059\u3079\u3066\u7A0E\u8FBC\u307F\u8868\u8A18", /*#__PURE__*/_jsx("br", {}), "\u203B\u91D1\u984D\u306F\u5272\u5F15\u9069\u7528\u5F8C\u306E\u91D1\u984D\u3092\u8868\u793A\u3057\u3066\u3044\u307E\u3059\u3002"]
            })
          })]
        }), (orderData === null || orderData === void 0 || (_orderData$data2 = orderData.data) === null || _orderData$data2 === void 0 ? void 0 : _orderData$data2.length) === 0 && !loading && /*#__PURE__*/_jsx("div", {
          className: styles.noContent,
          children: "\u304A\u652F\u6255\u3044\u5C65\u6B74\u306F\u3042\u308A\u307E\u305B\u3093"
        })]
      })
    })
  });
}